// Grouping of ticket lines for display and receipts. Moved out of utils.ts
// (which imports React hooks) so server code can import it; utils.ts
// re-exports it unchanged.

/** Group ticket services that share the same base service + provider but differ by area.
 *  Names matching "ServiceName · AreaName" are grouped; others pass through as-is. */
export interface GroupedService {
  key: string;
  baseName: string;
  areas: string[];
  totalPrice: number;
  originalIndices: number[];
  representative: { staff?: { staff_id: string; staff_name: string; role: string }[]; is_package?: boolean; package_sessions?: number; units?: number; unit_label?: string; tier_label?: string; redemption_package_id?: string; pending_package_redemption?: boolean; [k: string]: any };
}

export function groupServicesByArea<T extends { service_id: string; name: string; price: number; staff?: { staff_id: string; staff_name: string; role: string }[] }>(services: T[]): GroupedService[] {
  const map = new Map<string, GroupedService>();
  const order: string[] = [];

  services.forEach((svc, i) => {
    const parts = svc.name.split(' · ');
    const hasArea = parts.length >= 2;
    const baseName = hasArea ? parts[0] : svc.name;
    const areaName = hasArea ? parts.slice(1).join(' · ') : '';
    const staffKey = svc.staff?.map(s => s.staff_id).sort().join(',') || '';
    const key = `${svc.service_id}::${staffKey}::${baseName}`;

    const existing = map.get(key);
    if (existing && hasArea) {
      if (areaName) existing.areas.push(areaName);
      existing.totalPrice += svc.price;
      existing.originalIndices.push(i);
    } else {
      const group: GroupedService = {
        key,
        baseName,
        areas: areaName ? [areaName] : [],
        totalPrice: svc.price,
        originalIndices: [i],
        representative: svc as any,
      };
      map.set(key, group);
      order.push(key);
    }
  });

  return order.map(k => map.get(k)!);
}
